/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OrgsInputs */

const th_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`องค์กร`)
};

const en_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations`)
};

const ja_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`団体`)
};

const zh_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织`)
};

const es_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizaciones`)
};

const pt_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizações`)
};

const id_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisasi`)
};

const fr_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisations`)
};

const tl_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga organisasyon`)
};

const vi_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổ chức`)
};

const ko_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조직`)
};

const de_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisationen`)
};

const ru_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Организации`)
};

const tr_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuruluşlar`)
};

const it_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizzazioni`)
};

const pl_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organizacje`)
};

const uk_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Організації`)
};

const hi_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संगठन`)
};

const ar_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المؤسسات`)
};

const ms_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisasi`)
};

const bn_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংস্থা`)
};

const zh_tw2_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組織`)
};

const zh_hk2_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組織`)
};

const ur_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ادارے`)
};

const fa_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سازمان‌ها`)
};

const sw_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mashirika`)
};

const nl_nav_orgs = /** @type {(inputs: Nav_OrgsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organisaties`)
};

/**
* | output |
* | --- |
* | "Organisations" |
*
* @param {Nav_OrgsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const nav_orgs = /** @type {((inputs?: Nav_OrgsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OrgsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_nav_orgs(inputs)
	if (locale === "ja") return ja_nav_orgs(inputs)
	if (locale === "zh") return zh_nav_orgs(inputs)
	if (locale === "es") return es_nav_orgs(inputs)
	if (locale === "pt") return pt_nav_orgs(inputs)
	if (locale === "id") return id_nav_orgs(inputs)
	if (locale === "fr") return fr_nav_orgs(inputs)
	if (locale === "tl") return tl_nav_orgs(inputs)
	if (locale === "vi") return vi_nav_orgs(inputs)
	if (locale === "ko") return ko_nav_orgs(inputs)
	if (locale === "de") return de_nav_orgs(inputs)
	if (locale === "ru") return ru_nav_orgs(inputs)
	if (locale === "tr") return tr_nav_orgs(inputs)
	if (locale === "it") return it_nav_orgs(inputs)
	if (locale === "pl") return pl_nav_orgs(inputs)
	if (locale === "uk") return uk_nav_orgs(inputs)
	if (locale === "hi") return hi_nav_orgs(inputs)
	if (locale === "ar") return ar_nav_orgs(inputs)
	if (locale === "ms") return ms_nav_orgs(inputs)
	if (locale === "bn") return bn_nav_orgs(inputs)
	if (locale === "zh-TW") return zh_tw2_nav_orgs(inputs)
	if (locale === "zh-HK") return zh_hk2_nav_orgs(inputs)
	if (locale === "ur") return ur_nav_orgs(inputs)
	if (locale === "fa") return fa_nav_orgs(inputs)
	if (locale === "sw") return sw_nav_orgs(inputs)
	if (locale === "nl") return nl_nav_orgs(inputs)
	return en_nav_orgs(inputs)
});